import { baseApi } from "@/config/http-common";
import { EnbekSaveRequest } from "@/types/enbek/Enbek";

class EnbekDataService {
  eligibility(documentId: string | number): Promise<any> {
    return baseApi.get(
      `/integrations/enbek/documents/${documentId}/eligibility`
    );
  }

  registration(documentId: string | number): Promise<any> {
    return baseApi.get(
      `/integrations/enbek/documents/${documentId}/registration`,
      {
        silent: true,
      } as any
    );
  }

  save(documentId: string | number, data: EnbekSaveRequest): Promise<any> {
    return baseApi.post(
      `/integrations/enbek/documents/${documentId}/registration`,
      data
    );
  }

  submit(registrationId: number): Promise<any> {
    return baseApi.post(
      `/integrations/enbek/registrations/${registrationId}/submit`
    );
  }

  byEmployee(userId: string | number): Promise<any> {
    return baseApi.get(`/integrations/enbek/users/${userId}/registrations`);
  }
}

export default new EnbekDataService();
